/**
 * Zod input schemas: subscriptions. Split out of the one big schemas.ts (Oct 2026) so a session opens only the tool it
 * works on; nothing changed in the schemas themselves. Import as before, from '@daaily/shared' (or './schemas.js'
 * inside shared); the barrel re-exports every file in this folder. Shared primitives (EmailSchema, MonthSchema, …)
 * live in primitives.ts; cross-tool references are explicit imports between these files.
 */
import { z } from 'zod';
// ── Subscriptions ──
export const SubscriptionYearSchema = z.number().int().min(2000).max(2100);
export const SubscriptionUploadSourceSchema = z.object({
    year: SubscriptionYearSchema,
    filename: z.string().trim().min(1).max(260),
    // The client uploads the (large) export to Storage first, then passes the path
    // here — the file exceeds the callable's 32MB base64 request cap.
    storagePath: z.string().trim().min(1).max(400),
});
export const SubscriptionGetDashboardSchema = z.object({ year: SubscriptionYearSchema });
/** Subscriptions admin: grant/revoke a viewer's sub-nav access (APP-ADMIN only). */
export const SubscriptionSetUserPagesSchema = z.object({
    targetEmail: z.string().trim().toLowerCase().email(),
    pages: z.array(z.string().trim().min(1).max(40)).max(40),
});
//# sourceMappingURL=subscriptions.js.map